// Modular reduction using "classic" algorithm
export class Classic {
    private m: any;

    constructor(m: any) { this.m = m; }

    public convert(x: any) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }

    public revert(x: any) { return x; }
    public reduce(x: any) { x.divRemTo(this.m, null, x); }
    public mulTo(x: any, y: any, r: any) { x.multiplyTo(y, r); this.reduce(r); }
    public sqrTo(x: any, r: any) { x.squareTo(r); this.reduce(r); }
}